import React, { useEffect } from 'react';
import { TransactionData } from 'bnc-notify';
import { observer } from 'mobx-react-lite';
import { useContext } from 'react';
import { StoreContext } from '../../mobx/store-context';
import { Grid, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
import GasWidget from '../GasWidget';
import WalletWidget from '../WalletWidget';
import { CustomNotificationObject } from 'bnc-notify';

interface NotifyLink extends CustomNotificationObject {
	link: string;
}

const useStyles = makeStyles((theme: Theme) => ({
	root: {
		width: '100%',
		borderBottom: '1px solid #2B2B2B',
		position: 'sticky',
		top: 0,
		background: '#181818',
		zIndex: 1
	},
	container: {
		padding: theme.spacing(2.5, 6, 2.5, 0),
		textAlign: 'right'
	},
	button: {
		height: 36
	}
}));

const notifyLink = (transaction: TransactionData): NotifyLink => {
	return { link: `https://etherscan.io/tx/${transaction.hash}` };
};

const Header = observer(() => {
	const {
		uiState: { notification },
		onboard: { notify }
	} = useContext(StoreContext);
	const { enqueueSnackbar } = useSnackbar();
	const classes = useStyles();

	const enq = () => {
		if (!notification || !notification.message) return;

		// Notify doesn't support BSC currently so it is temporarily disabled for it
		if (notification.hash) {
			// then on each transaction...
			const { emitter } = notify.hash(notification.hash);
			emitter.on('all', tx => notifyLink(tx));
		} else {
			enqueueSnackbar(notification.message, { variant: notification.variant, persist: false });
		}
	};
	// Disable reason: Hook used for execution of enq() on change of notification.
	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(enq, [notification]);

	return (
		<div className={classes.root}>
			<Grid container>
				<Grid container className={classes.container} justifyContent="flex-end">
					<Grid item xs={7} container alignItems="center" justifyContent="flex-end" spacing={1}>
						<Grid item>
							<GasWidget className={classes.button} />
						</Grid>
						<Grid item>
							<WalletWidget className={classes.button} />
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</div>
	);
});

export default Header;
